var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C8.67168 20 7.4015 19.7405 6.23921 19.2684C6.13423 19.2258 6.07362 19.2013 6.02887 19.1845C6.02358 19.1825 6.01898 19.1808 6.01505 19.1794L6.0103 19.18C5.97339 19.185 5.92309 19.1933 5.82705 19.2093L2.24049 19.8071C2.07985 19.8339 1.90013 19.8639 1.74404 19.8757C1.57386 19.8885 1.30312 19.893 1.017 19.7703C0.663296 19.6186 0.381437 19.3367 0.229729 18.983C0.107009 18.6969 0.111482 18.4261 0.124327 18.256C0.136108 18.0999 0.166118 17.9202 0.19294 17.7596C0.194551 17.7499 0.19615 17.7403 0.197733 17.7308L0.790714 14.173C0.806721 14.0769 0.814996 14.0266 0.819998 13.9897L0.820633 13.9849C0.819203 13.981 0.817511 13.9764 0.815524 13.9711C0.798718 13.9264 0.774193 13.8658 0.731556 13.7608C0.259521 12.5985 0 11.3283 0 10Z",
    fill: "#6BB5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.74c0db2fc5a86a8b51d704b61f919255.svg";
export { ForwardRef as ReactComponent };